// extracted by mini-css-extract-plugin
module.exports = {"cover":"error_cover__3npsc","content":"error_content__3peW2"};